import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import PestleHelp from '../../../reusable/PestleHelp/PestleHelp';
import SliderRow from './../../../reusable/Form/SliderRow';

export default class SliderRiskAnglesLevels extends Component {

    constructor(props) {
        super(props);

        this.onSliderChange = this.onSliderChange.bind(this);
    }

    onSliderChange(value, riskAngleKey) {
        let changedRiskAngle = {};
        changedRiskAngle[riskAngleKey] = value;

        this.props.changeRiskAnglesSliders(changedRiskAngle);
    }

    render() {

        return (
            <div className="risk-sliders">

                <div className="risk-sliders__select-risk-level">
                    <div className="risk-sliders__select-risk-level--paragraph">
                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.selectRiskLevel"/>:
                        <PestleHelp position={'right'}/>
                    </div>
                </div>

                {
                    this.props.errorMessage ?
                        <div className="error-message"><FormattedMessage id={this.props.errorMessage}/></div>
                        :
                        null
                }

                <div className="risk-sliders__labels">
                        <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.dontInclude"/>
                        </span>
                    <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.highOnly"/>
                        </span>
                    <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.highMedium"/>
                        </span>
                    <span className="risk-angle-label">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.showAll"/>
                        </span>
                </div>

                <SliderRow key={'political-risk-angle-level-slider'}
                           ref={'politicalSlider'}
                           label={'General_CoreFunctionality_UIText_general.political'}
                           value={this.props.riskAngles.political}
                           onChange={this.onSliderChange}
                           onChangeData={'political'}
                           min={0}
                           max={3} />

                <SliderRow key={'economic-risk-angle-level-slider'}
                           ref={'economicSlider'}
                           label={'General_CoreFunctionality_UIText_general.economic'}
                           value={this.props.riskAngles.economic}
                           onChange={this.onSliderChange}
                           onChangeData={'economic'}
                           min={0}
                           max={3} />

                <SliderRow key={'social-risk-angle-level-slider'}
                           ref={'socialSlider'}
                           label={'General_CoreFunctionality_UIText_general.social'}
                           value={this.props.riskAngles.social}
                           onChange={this.onSliderChange}
                           onChangeData={'social'}
                           min={0}
                           max={3} />

                <SliderRow key={'technological-risk-angle-level-slider'}
                           ref={'technologicalSlider'}
                           label={'General_CoreFunctionality_UIText_general.technological'}
                           value={this.props.riskAngles.technological}
                           onChange={this.onSliderChange}
                           onChangeData={'technological'}
                           min={0}
                           max={3} />

                <SliderRow key={'legal-risk-angle-level-slider'}
                           ref={'legalSlider'}
                           label={'General_CoreFunctionality_UIText_general.legal'}
                           value={this.props.riskAngles.legal}
                           onChange={this.onSliderChange}
                           onChangeData={'legal'}
                           min={0}
                           max={3} />

                <SliderRow key={'environmental-risk-angle-level-slider'}
                           ref={'environmentalSlider'}
                           label={'General_CoreFunctionality_UIText_general.environmental'}
                           value={this.props.riskAngles.environmental}
                           onChange={this.onSliderChange}
                           onChangeData={'environmental'}
                           min={0}
                           max={3} />

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepOneComponents/CreateAlert.StepOne.SliderRiskAnglesLevels.jsx